import { CategoryChartQueryFn, CategoryChartQueryParam } from "../categoryChart";
import { FigureSolidDashKpiProviders } from "./categoryChartData.types";
import { PROVIDER_TITLE_CLASS, VALUE_STATUS_NAMING } from "../../Components/misc";

import { fetchFigureSolidDashKpiComparisonChartData } from "./fetchFigureSolidDashKpiComparisonChartData";

export const fetchAnnualBillingFigureSolidDashKpiComparisonChartData: CategoryChartQueryFn = async ({
    metadata,
    categoryChart,
    providers,
    kpis,
    category,
    ...rest
}: CategoryChartQueryParam): Promise<FigureSolidDashKpiProviders> => {
    const data = await fetchFigureSolidDashKpiComparisonChartData({
        metadata,
        categoryChart,
        providers: providers?.filter(
            d =>
                d.residentialTariffStruct !== "fixed" &&
                d.residentialTariffStruct !== "consumptionCharge" &&
                d.residentialTariffStruct !== "noChargeToResidents" &&
                d.residentialTariffStruct !== "fixedEntitlementAndExcessConsumptionCharge"
        ),
        kpis,
        category,
        ...rest
    });
    if (!data) return null;

    const _data = data as FigureSolidDashKpiProviders;

    const fixedProvider = providers?.find(
        d =>
            d.residentialTariffStruct === "fixed" ||
            d.residentialTariffStruct === "consumptionCharge" ||
            d.residentialTariffStruct === "noChargeToResidents" ||
            d.residentialTariffStruct === "fixedEntitlementAndExcessConsumptionCharge"
    );
    if (!fixedProvider) return _data;

    const providerTIdToIndex = _data?.waterProviders?.reduce((prev, cur, index) => {
        prev[cur?.tid] = index;
        return prev;
    }, {});

    const newData: FigureSolidDashKpiProviders = {
        ...data,
        waterProviders: providers,
        figures: providers.map(provider => {
            if (
                provider?.residentialTariffStruct === "fixed" ||
                provider?.residentialTariffStruct === "consumptionCharge" ||
                provider?.residentialTariffStruct === "noChargeToResidents" ||
                provider?.residentialTariffStruct === "fixedEntitlementAndExcessConsumptionCharge"
            ) {
                return {
                    value: VALUE_STATUS_NAMING.NA,
                    decimals: 0,
                    header: {
                        processed: `<div class="${PROVIDER_TITLE_CLASS}">${provider?.name} ${
                            _data?.year != null ? ` in ${_data?.year}` : ""
                        }</div>`,
                        value: `<div class="${PROVIDER_TITLE_CLASS}">${provider?.name} ${
                            _data?.year != null ? ` in ${_data?.year}` : ""
                        }</div>`
                    },
                    footer: {
                        processed: "This provider’s billing structure cannot be formulated into a per kl cost",
                        value: "This provider’s billing structure cannot be formulated into a per kl cost"
                    }
                };
            }

            return _data?.figures?.[providerTIdToIndex?.[provider?.tid]];
        }),
        graph: _data?.graph
    };

    return newData;
};
